import { cdnUrl } from "@/lib/cdn"

/**
 * Hero images for each city location, used across best/ and areas/ pages.
 * Locally generated images served from public/images/areas/cities/.
 */
export const LOCATION_IMAGES: Record<string, { url: string; alt: string }> = {
  bristol: {
    url: "/images/areas/cities/bristol-800w.webp",
    alt: "Bristol cityscape showing the Clifton Suspension Bridge and harbour",
  },
  brighton: {
    url: "/images/areas/cities/brighton-800w.webp",
    alt: "Brighton seafront with the iconic Palace Pier",
  },
  bath: {
    url: "/images/areas/cities/bath-800w.webp",
    alt: "Bath's Georgian architecture including the Royal Crescent",
  },
  oxford: {
    url: "/images/areas/cities/oxford-800w.webp",
    alt: "Oxford's skyline with university spires and the Radcliffe Camera",
  },
}

/**
 * Generate a srcSet string from an optimised image URL ending in -800w.webp.
 * Works for any image following the {name}-{width}w.webp naming convention.
 * Applies CDN prefix when configured.
 */
export function imageSrcSet(src: string): string {
  const base = src.replace(/-\d+w\.webp$/, "")
  return `${cdnUrl(`${base}-400w.webp`)} 400w, ${cdnUrl(`${base}-800w.webp`)} 800w, ${cdnUrl(`${base}-1200w.webp`)} 1200w`
}
